import { render } from "./About.vue?vue&type=template&id=5741efae&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=5741efae&lang=scss&scoped=true"

import exportComponent from "D:\\SI1280\\project\\Vue-portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5741efae"]])

export default __exports__